export default __webpack_public_path__ + "static/media/icon-search.9f98eb13.svg";